//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';

// === STYLE / MATERIAL UI ===
import {
  Box,
  TextField,
} from '@mui/material';

// === API ===
import { goToPageNumber } from 'api/prokey/prokey.websocket';

// === HOOKS ===
import { useTaskStatus } from 'components/hooks/useTaskStatus/index';

//#endregion  

//-----------------------------------------------------------------
export function GoToPage() { 
  //-----------------------------------------------------------------

  //#region [VALUES]

  const has_task = useTaskStatus();

  //#endregion

  //#region [STYLES]

  const _styles = {
    page_search: {
      display: 'flex',
      paddingTop: '0.2rem',
      width: '8rem',
      margin: '0 0.5rem',
    }
  }

  //#endregion

  //#region [EVENTS]  

  //-----------------------------------------------------------------     
  function onKeyDown_Search(event) {
    //-----------------------------------------------------------------     
    if (event.key === 'Enter') {
      const value = event.target.value;
      if (!isNaN(value)){
         goToPageNumber(value);
      }
    }
  };

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------    
  function display() {
    //-----------------------------------------------------------------
    if( !has_task ) return null;
    return (
      <TextField sx={_styles.page_search} size='small' label="Go to page" variant='outlined' autoComplete='off' onKeyDown={onKeyDown_Search} name='go_to_page_input'/>
    )
  }

  //#endregion

  return display();
}
